import { useTranslation } from 'react-i18next';
import { Controller, FieldValues } from 'react-hook-form';
import { TextArea } from '@shape-ds/components';
import { FormInputProps } from './FormInputProps';

export const FormTextField = <T extends FieldValues>({
  name,
  control,
  label,
  placeHolderText,
  isRequired,
  rows = 1,
  disabled,
  className = '',
  ...props
}: FormInputProps<T> & { rows: number; className?: string }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? t('components:inputs.required_field') : false }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div
          data-testid={name}
          className={`${name.replace(/\./g, '-')} form-text-field ${className}`}
        >
          <TextArea
            {...props}
            disabled={disabled}
            required={isRequired}
            data-testid={name}
            helperText={error ? error.message : null}
            error={!!error}
            onChange={onChange}
            value={value}
            fullWidth
            label={label}
            placeholder={placeHolderText}
            rows={rows}
          />
        </div>
      )}
    />
  );
};
